// Timing knobs shared across the lock sub-hooks. They match the backend
// FormLockSettings defaults; once those flow back from /acquire we can read
// them dynamically. For v1 these constants are the source of truth in the UI.

export const HEARTBEAT_INTERVAL_MS = 3000;
export const REQUEST_TIMEOUT_SECONDS = 30;

// Hold the "Access Granted" message on screen before swapping to the form so
// the user has a beat to register what happened.
export const ACCESS_GRANTED_DISPLAY_MS = 2000;

// When the holder is about to auto-grant, fire a preemptive saveDraft so the
// AC's "page saves any changes" applies whether the holder explicitly clicks
// Give Access OR lets the timer run out. Must fire BEFORE the server-side
// auto-grant — after it, the holder's session no longer owns the lock and
// any save would 409 against VerifyOwnership.
export const SAVE_BEFORE_AUTO_GRANT_AT_SECONDS = 5;
